import { ApplicationService, type CreatingApplicationCommand } from '@acme/api';
import { createApiError, createApiErrorFromCaught } from '@acme/foundation';
import { createEvent, createStore } from 'effector';

export type ApplicationFormationResult = null | {
  type: 'drafted' | 'confirmed' | 'failed-draft' | 'failed-confirm';
  title: string;
  message?: string;
  applicationId?: string;
  applicationCode?: string | null;
};

export const formOpened = createEvent();
export const resetResult = createEvent();
export const createSucceeded =
  createEvent<NonNullable<ApplicationFormationResult>>();

export const draftSavedSuccessfully = createEvent<{
  applicationId: string;
  applicationCode?: string | null;
}>();

export const $result = createStore<ApplicationFormationResult>(null)
  .on(resetResult, () => null)
  .on(createSucceeded, (_, payload) => payload)
  .on(draftSavedSuccessfully, (_, { applicationId, applicationCode }) => ({
    type: 'drafted',
    title: `Заявка ${applicationCode ?? ''} успешно сохранена!`.trim(),
    applicationId,
    applicationCode: applicationCode ?? null,
  }));

const DEFAULT_ERROR_MESSAGE = 'Не удалось отправить запрос';

export async function createApplicationClient(
  command: CreatingApplicationCommand
): Promise<{ applicationId: string; applicationCode?: string | null }> {
  try {
    const res = await ApplicationService.postApiV1ApplicationCreate({
      requestBody: command,
    });
    if (!res.isSuccess || !res.data) {
      throw createApiError(res.errorText || DEFAULT_ERROR_MESSAGE, res);
    }
    const app = await ApplicationService.getApiV1Application({
      id: res.data,
    });
    return {
      applicationId: res.data,
      applicationCode: app.data?.code ?? null,
    };
  } catch (e) {
    const err = createApiErrorFromCaught(e, DEFAULT_ERROR_MESSAGE);
    if (err) throw err;
    throw e;
  }
}
